<template>
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="800px">
            <v-form
                ref="form"
                v-model="valid"
            >
                <v-stepper v-model="stepNumber">
                    <v-stepper-header>
                        <v-stepper-step
                            color="blue lighten-1"
                            :complete="stepNumber > 1"
                            step="1"
                        >
                            Имя бота
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step
                            color="blue lighten-1"
                            :complete="stepNumber > 2"
                            step="2"
                        >
                            Тип бота
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step
                            color="blue lighten-1"
                            step="3"
                            :rules="[() => false]"
                        >
                            Токен
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1" color="blue lighten-1">
                            <v-card
                                class="mb-12"
                                color="grey lighten-4"
                                height="200px"
                            >
                                <v-col cols="12" xs12 class="px-3">
                                    <v-text-field
                                        label="Имя бота"
                                        required
                                        v-model="form.title"
                                        :counter="50"
                                        class="ma-0 pa-0"
                                        :rules="[rules.required, rules.maxLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                            </v-card>

                            <v-btn
                                color="blue lighten-1"
                                @click="stepNumber = 2"
                                :dark="activeNext"
                                :disabled="!activeNext"
                            >
                                Продолжить
                            </v-btn>

                            <v-btn text>
                                Отмена
                            </v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card
                                class="mb-10"
                                color="grey lighten-4"
                                height="270px"
                            >
                                <v-col cols="12" xs12 class="px-3">
                                    <v-radio-group
                                        label="Выберите подходящий тип бота исходя их описания"
                                        required
                                        v-model="form.type"
                                        class="ma-0 pa-0"
                                    >
                                        <v-row>
                                            <v-col cols="3" class="pb-0 pt-2">
                                                <v-radio label="Магазин" :value="getBotTypeId(botTypeEnumComputed.SHOP)"></v-radio>
                                            </v-col>
                                            <v-col cols="9" class="pl-0 pb-0 pt-2">
                                                Шаблон для интернет-магазинов с доставкой. Например: доставка еды, продуктов и прочее.
                                                Для создания товаров достаточно загрузить файл excel и товары будут созданы автоматически.
                                            </v-col>
                                            <v-col cols="3" class="pb-0 pt-2">
                                                <v-radio label="Автомойка" :value="3"></v-radio>
                                            </v-col>
                                            <v-col cols="9" class="pl-0 pb-0 pt-2">
                                                Шаблон для онлайн записи на мойку. Данный бот позволяет настраивать расписание администраторам прямо из чат-бота, не заходя на платформу.
                                            </v-col>
                                            <v-col cols="3" class="pb-0 pt-2">
                                                <v-radio label="Обычный" :value="1"></v-radio>
                                            </v-col>
                                            <v-col cols="9" class="pl-0 pb-0 pt-2">
                                                Чистый шаблон без каких-либо предустановок. Подходит для опытных пользователей платформы Chatway.
                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </v-col>
                            </v-card>

                            <v-btn
                                color="blue lighten-1"
                                @click="stepNumber = 3"
                                :dark="activeNext"
                                :disabled="!activeNext"
                            >
                                Продолжить
                            </v-btn>

                            <v-btn text>
                                Отмена
                            </v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-card
                                class="mb-12"
                                color="grey lighten-4"
                                height="270px"
                            >
                                <v-col cols="12" xs12 class="px-3">
                                    <v-text-field
                                        label="Токен бота"
                                        required
                                        v-model="form.token_tg"
                                        class="ma-0 pa-0"
                                        :rules="[rules.required,rules.maxLengthTitle]"
                                    ></v-text-field>
                                    <p>
                                        Создайте токен в телеграм зайдя в <a href="https://t.me/BotFather" target="_blank">BotFather Telegram</a> и набрав команду /newbot.
                                        После создания бота скопируйте токен в текстовое окно.
                                    </p>
                                </v-col>
                            </v-card>

                            <v-btn :dark="activeNext" color="blue lighten-1" @click="createBot" :disabled="!activeNext">
                                Продолжить
                            </v-btn>

                            <v-btn text @click="show = false">
                                Отмена
                            </v-btn>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-form>
        </v-dialog>
    </v-layout>
</template>

<script>
import * as botTypeEnum from '@enums/bot/botTypeEnum'
import * as apiconfig from '@/apiConfig'
import {getBotTypeId} from "@enums/bot/botTypeEnum";
// import {getBotTypeTitle} from "../../../../utils/constants/bot/botTypes";
export default {
    name: 'BotCreateForm',
    data() {
        return {
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 50) || 'Максимальная длина названия 20 символов.'
            },
            show: false,
            form: {
                title: '',
                type: 2,
                token_tg: ''
            },
            formDefault: {
                title: '',
                type: 2,
                token_tg: ''
            },
            selectedMenu: 0,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            valid: false,
            stepNumber: 1
        }
    },
    props: {
        visible: Boolean
    },
    methods: {
        createBot() {
            console.log('asd')
            this.$store.dispatch('bots/createBot', this.form).then(result => {
                if (result.ok) {
                    console.log(result)
                    let botId = result.response.data.id
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Бот успешно создан!'
                    this.snackbar = true
                    let url = 'bot' + botId + '/message?message=start'
                    if (result.response.data.type === botTypeEnum.getBotTypeId(botTypeEnum.SHOP)) {
                        url = 'bot' + botId + '/catalog?message=start'
                    }
                    this.show = false
                    setTimeout(() => {
                        this.$router.push({path: url})
                    }, 2000);
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = result.response.text
                    this.snackbar = true
                }
            })
        },
        getBotTypeId(typeId) {
            return this.botTypeEnumComputed.getBotTypeId(typeId)
        }
    },
    watch: {
        stepNumber(value) {
            if (value == 2) {
                console.log(this.form)
            }
        },
        visible: {
            handler: function () {
                this.visible === true ? this.show = true : this.show = false
                if (this.visible) {
                    this.form = Object.assign({}, this.formDefault)
                    this.stepNumber = 1
                }
            },
            deep: true
        },
        show() {
            if (this.show === false) {
                this.form = Object.assign({}, this.formDefault)
                this.$refs.form.resetValidation()
                this.$emit('close')
                this.stepNumber = 1
            }
        }
    },
    computed: {
        activeNext() {
            return this.form.title.length > 0 && (this.stepNumber < 3 || this.form.token_tg.length > 0)
        },
        botTypeEnumComputed() {
            return botTypeEnum
        }
    }

}
</script>

<style scoped>

</style>
